import { createApp } from "vue";
import "amfe-flexible";
import router from "@/router";
import store from "@/store";
import App from "./App.vue";
import { Icon } from "vant";
import "@/assets/style/reset.scss";
import "@/assets/style/common.scss";
import "vant/lib/index.css";
// 下面四个组件需要单独引入样式
// import "vant/es/toast/style";
// import "vant/es/dialog/style";
// import "vant/es/notify/style";
// import "vant/es/image-preview/style";
// 引入诸葛
import '@/zhuge/config.js';

import { Toast } from 'vant'; 
import './permission'
const app = createApp(App);
app.config.compilerOptions.isCustomElement = (tag) => {
	return tag.startsWith('wx-open-launch-weapp')
}
app.use(store).use(router).use(Icon).use(Toast).mount("#app");
